module.exports = __webpack_public_path__ + "img/stretch-warp-compress.0050804e.png";